import React from 'react'
import { OverflowMenu } from '@ublique/components/OverflowMenu'
import { useTranslation } from 'react-i18next'

import { openModal } from 'components/Modal/actions'
import { removePurgerScenario } from 'pages/Scenario/actions'
import { tableParser } from 'pages/Scenario/utils/table'
import { scenarioStore } from 'services/state'
import { addNotification } from 'components/Notifications/actions'
import { uniqueId } from 'lodash'
import { useOverflowMenuParent } from 'pages/Scenario/Manager/utils/table'
import {
  editPurger,
  getPurgerScenarios,
  simulatePurger
} from 'services/api/purger'
import { getJobTypes } from '../utils/options'

export const useOverflowMenu = ({
  data,
  gridApi
  // modelPermissions,
  // showOutputPermission
}) => {
  const jobTypes = getJobTypes()
  const { id, enabled } = data
  const { t } = useTranslation(['PurgerPlatform', 'Purger'])
  useOverflowMenuParent()

  const getAllPurgerScenarios = async () => {
    try {
      const { body } = await getPurgerScenarios()

      scenarioStore.update((oldState) => ({
        ...oldState,
        purgerData: body
      }))
      return body
    } catch (err) {
      console.error(err)
      return []
    }
  }

  const update = async (message) => {
    gridApi?.showLoadingOverlay()
    gridApi?.setRowData([])
    const items = await getAllPurgerScenarios()
    gridApi?.applyTransaction({
      add: tableParser({
        rowData: items
      })
    })
    gridApi?.hideOverlay()

    addNotification({
      id: uniqueId('notif-'),
      type: 'inline',
      kind: 'success',
      title: t(`Scenario:${message}`)
    })
  }

  const deleteAndUpdate = async () => {
    await removePurgerScenario(data)
    await update('SCENARIO_DELETED_TITLE')
  }

  const editPurgerScenario = ({ enablingMode }) => {
    const _data = enablingMode ? { ...data, enabled: true } : data

    openModal('purger', {
      onSave: async (scenario) => {
        await editPurger(scenario, _data?.id)
        await update('SCENARIO_EDITED_TITLE')
      },
      defaultPurgerData: _data,
      isPurgerEditing: true,
      jobTypes,
      t
    })
  }

  const onEnabling = () => {
    // If cron data is null, then, to enable scenario, cron dates need to be added
    if (!data.cronStart && !data.cronEnd) {
      editPurgerScenario({ enablingMode: true })
    } else {
      openModal('enablingScenario', {
        scenario: data,
        onSubmit: async (scenario) => {
          await editPurger(
            {
              ...scenario,
              enabled: !enabled
            },
            data?.id
          )
          await update('SCENARIO_EDITED_TITLE')
        }
      })
    }
  }

  const onSimulateScenario = () => {
    openModal('simulateScenario', {
      t,
      onSubmit: async (payload) => {
        await simulatePurger({ id: data?.id, body: payload })
        await update('SCENARIO_SIMULATED')
      }
    })
  }

  const config = [
    {
      title: enabled ? t('Table.DISABLE') : t('Table.ENABLE'),
      action: onEnabling
    },
    {
      title: t('Table.EDIT'),
      action: editPurgerScenario
    },
    {
      title: t('Table.SIMULATE'),
      action: onSimulateScenario
    },
    {
      title: t('Table.DELETE'),
      action: async () => {
        openModal('deletingScenario', {
          onSubmit: deleteAndUpdate
        })
      }
    }
  ]

  return () => (
    <OverflowMenu ariaLabel='Menu' direction='top' flipped>
      {config.map(({ title, action, permission }) => (
        <OverflowMenu.Item
          key={`${id}-${title}`}
          itemText={title}
          // disabled={checkDisabled(permission, action)}
          onClick={action}
        />
      ))}
    </OverflowMenu>
  )
}
